
import { createAction, props } from "@ngrx/store";
import { EntityEspeciesCertificables } from "./entity-especies-certificables.model";

export const EntityEspeciesCertificablesLoadRequest = createAction(
  '[ENTITYESPECIESCERTIFICABLES] Load Request'
);

export const EntityEspeciesCertificablesLoadFailure = createAction(
  '[ENTITYESPECIESCERTIFICABLES] Load Failure',
  props<{ error: Error }>()
);

export const EntityEspeciesCertificablesLoadSuccess = createAction(
  '[ENTITYESPECIESCERTIFICABLES] Load Success',
  props<{ items: EntityEspeciesCertificables[] }>()
);

export const EntityEspeciesCertificablesAddRequest = createAction(
  '[ENTITYESPECIESCERTIFICABLES] Add Request',
  props<{ item: EntityEspeciesCertificables }>()
);

export const EntityEspeciesCertificablesAddFailure = createAction(
  '[ENTITYESPECIESCERTIFICABLES] Add Failure',
  props<{ error: Error }>()
);

export const EntityEspeciesCertificablesAddSuccess = createAction(
  '[ENTITYESPECIESCERTIFICABLES] Add Success',
  props<{ item: EntityEspeciesCertificables }>()
);

export const EntityEspeciesCertificablesDeleteRequest = createAction(
  '[ENTITYESPECIESCERTIFICABLES] Delete Request',
  props<{ item: EntityEspeciesCertificables }>()
);

export const EntityEspeciesCertificablesDeleteFailure = createAction(
  '[ENTITYESPECIESCERTIFICABLES] Delete Failure',
  props<{ error: Error }>()
);

export const EntityEspeciesCertificablesDeleteSuccess = createAction(
  '[ENTITYESPECIESCERTIFICABLES] Delete Success',
  props<{ item: EntityEspeciesCertificables }>()
);

export const EntityEspeciesCertificablesUpdateRequest = createAction(
  '[ENTITYESPECIESCERTIFICABLES] Update Request',
  props<{ item: EntityEspeciesCertificables }>()
);

export const EntityEspeciesCertificablesUpdateFailure = createAction(
  '[ENTITYESPECIESCERTIFICABLES] Update Failure',
  props<{ error: Error }>()
);

export const EntityEspeciesCertificablesUpdateSuccess = createAction(
  '[ENTITYESPECIESCERTIFICABLES] Update Success',
  props<{ item: EntityEspeciesCertificables }>()
);
